var map = {
	"./ar.json": 4401,
	"./de.json": 6477,
	"./en-US.json": 7964,
	"./es.json": 2706,
	"./fr.json": 4554,
	"./hi.json": 3501,
	"./it.json": 6851,
	"./pt.json": 4606,
	"./ru.json": 3715,
	"./zh-CN.json": 8318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9401;